import { render, staticRenderFns } from "./GroupContactInfo.vue?vue&type=template&id=c13c3fae"
import script from "./GroupContactInfo.vue?vue&type=script&lang=ts"
export * from "./GroupContactInfo.vue?vue&type=script&lang=ts"
import style0 from "./GroupContactInfo.vue?vue&type=style&index=0&id=c13c3fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports